import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import { container } from "../../lib/style";

import logo from "./logo.png";

const styles = () => ({
  container: {
    ...container,
    zIndex: "2",
    textAlign: "center",
    color: "#00bcd4",
  },
  "@keyframes heartbeat": {
    "0%": {
      transform: "scale(0.75)",
    },
    "20%": {
      transform: "scale(1)",
    },
    "40%": {
      transform: "scale(0.75)",
    },
    "60%": {
      transform: "scale(1)",
    },
    "80%": {
      transform: "scale(0.75)",
    },
    "100%": {
      transform: "scale(0.75)",
    },
  },
  img: {
    display: "block",
    margin: "auto",
    animation: "$heartbeat 1s infinite",
  },
});

const useStyles = makeStyles(styles);

export const BigLoading = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className="fa fa-spinner fa-spin" style={{ fontSize: 80 }}></div>
      {/* <img className={classes.img} src={logo} /> */}
    </div>
  );
};

export default BigLoading;
